import { gql } from '@apollo/client';

export const SEND_SINGLE_BRAINTREE_TRANSACTION = gql`
mutation sendSingleBrainTreeTransaction($token : String!,$paymentdata:CustomerPayment!) {
  sendSingleBrainTreeTransaction(token: $token, paymentdata:$paymentdata) {
    status
    data
    error
  }
}
`;

export const SEND_BRAINTREE_VERIFICATION_TRANSACTIONS = gql`
mutation sendBrainTreeVerificationTransactions($phone : String!) {
  sendBrainTreeVerificationTransactions(phone: $phone) {
    status
    data
    error
  }
}
`;

export const CONIFRM_BRAINTREE_VERIFICATION_TRANSACTIONS = gql`
mutation verifyTempBrainTreeTransactions($phone : String!, $amount1 : Float!) {
  verifyTempBrainTreeTransactions(phone: $phone, amount1: $amount1) {
    status
    data
    error
  }
}
`;